export default __webpack_public_path__ + "static/media/login_background.7f791d0e.jpg";